import Vimeo from '@vimeo/player';

// https://github.com/vimeo/player.js/
// <div class="vimeo-video" data-id=""></div>
class VimeoPlayer {
    constructor(el) {
      this.id = el.dataset.id;
      this.placeholder = el.querySelector('.placeholder');

      this.isBackground = el.classList.contains("background");
      this.isAutoplay = el.classList.contains('autoplay');
      this.shouldAttemptAutoplay = this.isAutoplay || this.isBackground;

      let options = {
        id: this.id,
        responsive: true,
        background: false,
        playsinline: true,
      };
  
      if (this.isBackground) {
        options = Object.assign(options, {
          background: true,
          muted: true,
          controls: false,
          loop: true,
          autoplay: true,
          autopause: false,
        });
      }
  
      if (this.isAutoplay) {
        options = Object.assign(options, {
          autoplay: true,
          muted: true,
          autopause: false,
        });
      }
  
      this.player = new Vimeo(el, options);

      this.player.on('loaded', async () => {
          if (this.placeholder) {
            this.placeholder.classList.add('hidden');
          }

          if (!this.shouldAttemptAutoplay) {
            return;
          }

          try {
            await this.player.setMuted(true);
            await this.player.play();
          } catch (error) {
            // Intentionally no-op: some browsers block autoplay despite muted/inline settings.
          }
      });
  
      this.player.on('play', () => {
          if (this.placeholder) {
            this.placeholder.classList.add('hidden');
          }
      });
    }
}

const videos = document.querySelectorAll(".vimeo-video");

if (videos) {
  videos.forEach(function (video) {
      new VimeoPlayer(video);
  });
}
